import { useState } from "react"
import { LuSearch } from "react-icons/lu";
import { RiMenu3Line } from "react-icons/ri"
import { Box, HStack, IconButton } from "@chakra-ui/react"
import { Deal } from "@/types"
import { SearchClientsModal } from "../modals";
import { Text } from "../ui"

interface Props {
  deals: Deal[]
  onOpenDrawer?: () => void
}

export const DealManagerNavBar = ({ deals, onOpenDrawer }: Props) => {
  const [isSearchModalOpen, setIsSearchModalOpen] = useState(false);

  return (
    <HStack pt={2} pb={2} pr={{ base: 3, md: 5 }} bg="white" w="100%" minH="56px" borderBottom={"1px solid"} borderColor="gray.200">
      {onOpenDrawer && (
        <IconButton
          aria-label="Open menu"
          variant="ghost"
          size="sm"
          ml={2}
          onClick={onOpenDrawer}
        >
          <RiMenu3Line size={22} />
        </IconButton>
      )}
      <Box
        ml={5}
        w={{ base: "200px", md: "300px" }}
        border="1px solid rgba(0,0,0, 0.2)"
        borderRadius="full"
        p={2}
        cursor="text"
        onClick={() => setIsSearchModalOpen(true)}
      >
        <HStack>
          <LuSearch color="rgba(0, 0, 0, 0.5)" size={20} />
          <Text fontSize="sm" color="blackAlpha.700">
            Search Deals
          </Text>
        </HStack>
      </Box>
      <SearchClientsModal
        deals={deals}
        isOpen={isSearchModalOpen}
        onClose={() => setIsSearchModalOpen(false)}
      />
    </HStack>
  )
}
